// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1j-e";
export var animationRelative = "_1j-d";
export var backdropBlur = "_1j-0";
export var detailLabelCell = "_1j-q";
export var detailTable = "_1j-p";
export var detailValueCell = "_1j-r";
export var documentTypeIcon = "_1j-y";
export var documentTypeOption = "_1j-x";
export var dropdownMatchDatePicker = "_1j-3";
export var evidenceCardContent = "_1j-w";
export var gorgiasTicketCard = "_1j-s";
export var iconTertiary = "_1j-z";
export var integrationCard = "_1j-1";
export var integrationLogoBox = "_1j-2";
export var mainColumnSticky = "_1j-v";
export var maxWidthContainer = "_1j-t";
export var modalContentBody = "_1j-a";
export var modalHeaderImage = "_1j-5";
export var modalImageLabel = "_1j-7";
export var modalImageOverlay = "_1j-6";
export var modalImageSubtitle = "_1j-9";
export var modalImageTitle = "_1j-8";
export var modalImageWrapper = "_1j-4";
export var modalStickyFooter = "_1j-b";
export var sidebarColumn = "_1j-u";
export var timelineLine = "_1j-m";
export var timelineLineBlack = "_1j-o _1j-m";
export var timelineLineGray = "_1j-n _1j-m";
export var timelineLineHeight = "_1j-l";
export var tlDotActivate = "_1j-i";
export var tlDotActivateAnim = "_1j-h";
export var tlDotHide = "_1j-g";
export var tlDotHideAnim = "_1j-f";
export var tlLineActivate = "_1j-k";
export var tlLineActivateAnim = "_1j-j";
export var uploadedFileRow = "_1j-c";